import {
  getEntity as getEntityFromRoot,
  getEntityMap as getEntityMapFromRoot,
} from 'data/graphql/reducer'
import { getListState as getListStateFromRoot } from 'data/graphql/pagination'

import {
  getViewState as getViewStateFromRoot,
  getRawViewState as getRawViewStateFromRoot,
} from 'data/ui/viewState'

// GraphQL selectors
export const getEntityMap = (state, typename) =>
  getEntityMapFromRoot(state.data, typename)
export const getEntity = (state, typename, id) =>
  getEntityFromRoot(state.data, typename, id)

// ViewState
export const getViewState = (state, viewId) =>
  getViewStateFromRoot(state.ui.viewState, viewId)
export const getRawViewState = (state, viewId) =>
  getRawViewStateFromRoot(state.ui.viewState, viewId)

export const getListState = listName => {
  const getter = getListStateFromRoot(listName)
  return state => getter(state.pagination)
}
